<template>
  <div
      :class="['includes-item', {active: collapse}]"
      @click="collapse = !collapse">
    <div class="includes-item__head">
      <h3 class="item-title">
        <span v-html="icon" class="item-icon"></span>
        {{ title }}
      </h3>
      <span class="includes-item__head-btn">
        <i class="icon-arrow"></i>
      </span>
    </div>
    <div
        class="includes-item__content includes-special-formatting"
        v-html="description"></div>
  </div>
</template>

<script>
import {getItemData} from "@/components/ItineraryIncludesExcludesSpoiler/IncludesExcludesDataHelpers";

export default {
  name: 'ItineraryIncludesExcludesSpoiler',
  methods: { getItemData },
  data() {
    return {
      collapse: false,
    }
  },
  props: ['language', 'itemKey', 'description'],
  computed: {
    title() {
      return getItemData(this.itemKey, this.language).title;
    },
    icon() {
      return getItemData(this.itemKey, this.language).icon;
    }
  }
}
</script>

<style lang="scss" scoped>
.item-icon {
  margin-right: 11px;
  width: auto;
  height: 100%;
}
.item-title {
  display: flex;
  align-items: center;
}
.includes-item.active .includes-item__head h3 {
  color: #77B017;
}
</style>

<style lang="scss">
.includes-special-formatting {

  h3 {
    color: rgb(96, 96, 96);
    font-size: 1.8rem;
    margin-bottom: 1px;
    text-transform: none;
  }

  .note-decor {
    padding-left: 30px;
    position: relative;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
  }

  .note-decor:before {
    position: absolute;
    content: url("data:image/svg+xml;base64,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");
    width: 18px;
    height: 18px;
    left: 0;
    line-height: 21px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .br {
    margin-bottom: 8px;
  }
}
</style>